import { render, staticRenderFns } from "./buildPartners.vue?vue&type=template&id=5d4e7132&"
import script from "./buildPartners.vue?vue&type=script&lang=js&"
export * from "./buildPartners.vue?vue&type=script&lang=js&"
import style0 from "./buildPartners.vue?vue&type=style&index=0&id=5d4e7132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports